import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Button, Card, CardBody, CardTitle, Container} from "reactstrap";
import {Field, reduxForm} from 'redux-form';

import Logo from '../../assets/svg/logo-blue.svg';
import {InputField} from "../../validation/ReduxFormInput";
import {normalizePhone} from "../../util/normalizers";

class ClaimPropertyContainer extends Component {
    render() {
        return (
            <div>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    <img style={{maxWidth: '100px'}} src={Logo} alt="PolyRents"/>
                </div>
                <Container>
                    <Card className="pr-card">
                        <CardTitle><h2>Let's find you some tenants</h2></CardTitle>
                        <CardBody>
                            <form>
                                <Field name="email" label="Email" component={InputField} type="email"/>
                                <Field name="phone" label="Phone" placeholder="555-555-5555" component={InputField} normalize={normalizePhone}/>
                                <Button type="submit" color="success" outline>Let's Go!</Button>
                            </form>
                        </CardBody>
                    </Card>
                </Container>
            </div>
        );
    }
}

ClaimPropertyContainer = reduxForm({
    form: 'claim'
})(ClaimPropertyContainer);

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    _fetchUnclaimedProperties(info) {

    }
});

export default connect(mapStateToProps, mapDispatchToProps)(ClaimPropertyContainer);


// WEBPACK FOOTER //
// ./src/containers/unclaimed/ClaimPropertyContainer.js